// router.js
import {createRouter, createWebHistory} from 'vue-router';

// Components
import GenericErrorPage from '@/javascript/views/components/generic-error.vue';
import UnauthorizedPage from "@/javascript/views/components/unauthorized.vue";
import Dashboard from "@/javascript/views/clientDashboard/Dashboard.vue";
import ThankYou from "../views/animations/ThankYou.vue";
import DonatableShowPage from "../views/landing/DonatableShowPage.vue";
import DonationForm from "../views/donation/DonationForm.vue";
import DonorDashboard from "@/javascript/views/donorDashboard/DonorDashboard.vue";
import RouteGuard from "../views/RouteGuard.vue";
import ClientWebsite from "../views/landing/ClientWebsite.vue";
import HouseholdInviteResponse from "../views/households/HouseholdInviteResponse.vue";


const routes = [
  // { path: '/', redirect: '/dashboard'},
  {path: '/', component: RouteGuard},
  {
    path: '/donate/thank_you',
    component: ThankYou,
    meta: {robots: 'noIndex, noFollow'}
  },
  {
    path: '/error',
    component: GenericErrorPage,
    props: true,
    meta: {robots: 'noIndex, noFollow'}
  },
  {
    path: '/unauthorized',
    component: UnauthorizedPage,
    props: true,
    meta: {robots: 'noIndex, noFollow'}
  },
  {
    name: 'client-dashboard-scoped',
    path: '/dashboard/:panel?/:id?',
    component: Dashboard,
    meta: {robots: 'noIndex, noFollow'}
  },
  {
    name: 'client-dashboard',
    path: '/:org?/dashboard/:panel?/:id?',
    component: Dashboard,
    meta: {robots: 'noIndex, noFollow'}
  },
  {
    path: '/donor/dashboard/:panel?/:id?',
    component: DonorDashboard,
    meta: {robots: 'noIndex, noFollow'}
  },
  {
    name: 'donor-dashboard',
    path: '/:org?/donor/dashboard/:panel?/:id?',
    component: DonorDashboard,
    meta: {robots: 'noIndex, noFollow'}
  },
  {
    name: 'landing',
    path: '/:org?/donate',
    alias: ['/donate', '/landing-page/:org?'],
    component: ClientWebsite,
    meta: {robots: 'noIndex, noFollow'}
  },
  {
    name: 'donatable-show',
    path: '/:org?/donate/:slug',
    component: DonatableShowPage,
    meta: {robots: 'noIndex, noFollow'}
  },
  {
    name: 'donation-form',
    path: '/donate/form/:org?',
    component: DonationForm,
    meta: {robots: 'noIndex, noFollow'}
  },
  {
    name: 'household-invite-response',
    path: '/household-invites/:token/:action',
    component: HouseholdInviteResponse,
    meta: {robots: 'noIndex, noFollow'}
  },
  {
    path: '/:pathMatch(.*)*',
    component: GenericErrorPage,
    meta: {robots: 'noIndex, noFollow'}
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(() => {
  window.scrollTo(0, 0);
});

export default router;
